import React from 'react';
import GetCurrentTheme from './GetCurrentTheme';

const ThemeProvider = ({ children }) => {
  const theme = GetCurrentTheme();

  if (!children) return null;

  return React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { theme });
    }
    return child;
  });
};

export default ThemeProvider;